<template>
    <div>
        <h1 class="float-right mr-4 mt-2">
            <span v-if="accumulatedDecision === consts.DECISION_STATUS_APPROVED"
                  v-b-tooltip="`Deze blokkering is vrijgegeven omdat alle redenen zijn vrijgegeven`"
                  class="fa fa-thumbs-up text-success"></span>
            <span v-else-if="accumulatedDecision === consts.DECISION_STATUS_DENIED"
                  v-b-tooltip="`Deze blokkering is definitief omdat 1 reden als negatief is beoordeeld, of omdat de gehele groep als definitief-blokkeren is ingesteld.`"
                  class="fa fa-thumbs-down text-danger"></span>
            <span v-else-if="accumulatedDecision === consts.DECISION_STATUS_INVALIDATED_BY_DATA_CHANGE"
                  v-b-tooltip="`Deze blokkering is irrelevant geworden omdat de data van de order is gewijzigd. De order wordt opnieuw gecontroleerd a.d.h.v. de nieuwe data.`"
            >
                <font-awesome-icon icon="ban" class="text-secondary"/>
            </span>
            <span v-else class="text-secondary icon-dash"
                  v-b-tooltip="`Nog niet alle redenen in deze blokkering zijn beoordeeld`"
            >-</span>
        </h1>

        <div v-if="holdModelType === 'App\\Models\\Omt\\DispatchRequest'">
            <b-card-title class="font-size-lg">
              <span class="text-uppercase">{{ $t('omt.gui.general.label.delivery') }}</span>
            </b-card-title>
              <strong>
                  {{ $t('omt.gui.general.label.dispatch-requests.dispatcher-type') }}:
              </strong> {{holdReasonsForModel.dispatcher_type}}<br/>
              <strong>{{ $t('omt.gui.general.label.dispatch-requests.dispatcher-identifier') }}:</strong> {{holdModel.dispatcher_identifier}}<br />
              <strong>{{ $t('omt.gui.general.label.created-at') }}:</strong> {{formatDateTime(holdModel.created_at)}}<br />
              <template v-if="holdModel.updated_at !== holdModel.created_at">
                <strong>
                  {{ $t('omt.gui.general.label.updated-at') }}:
                </strong> {{formatDateTime(holdModel.updated_at)}}<br />
              </template>
              <strong>{{ $t('omt.gui.general.label.products') }}:</strong>
              <ul class="pl-4">
                  <li v-for="name in getProductNamesForHoldModel(holdModel)" v-html="name" :key="name"></li>
              </ul>
        </div>

        <div v-else-if="holdModelType === 'App\\Models\\Omt\\SalesOrder'">

            <b-card-title class="font-size-lg">
                <span class="text-uppercase">{{ $t('omt.gui.general.label.salesOrder') }}</span>
            </b-card-title>

            <strong></strong>
        </div>

        <div v-else>
            <b-alert show variant="danger">Onbekend type blokkering. Neem contact op met OmniStock.</b-alert>
        </div>

        <b-alert :show="hasNotApprovableReason" variant="info" class="mt-4 mb-0">
            <font-awesome-icon icon="circle-info" class="text-info mr-2"/>
            Deze blokkering kan niet vrijgegeven worden. In plaats daarvan kan je de data van de order wijzigen. Hierna wordt de order opnieuw beoordeeld.
        </b-alert>
    </div>
</template>

<script>
import {
    DECISION_STATUS_APPROVED,
    DECISION_STATUS_DENIED,
    DECISION_STATUS_INVALIDATED_BY_DATA_CHANGE,
} from "../HoldReasonsReview.vue"
import _ from "lodash";

export default {
    name: 'HoldReasonModelInfoHeader',

    props: {
        salesOrder: {required: true},
        holdReasonsForModel: {required: true, default: []},
        holdModelType: {required: true, default: null},
    },

    data() {
        return {
            accumulatedDecision: null,
            holdModel: {},
            consts: {
                DECISION_STATUS_APPROVED: DECISION_STATUS_APPROVED,
                DECISION_STATUS_DENIED: DECISION_STATUS_DENIED,
                DECISION_STATUS_INVALIDATED_BY_DATA_CHANGE: DECISION_STATUS_INVALIDATED_BY_DATA_CHANGE,
            }
        }
    },

    mounted() {
        this.holdModel = this.holdReasonsForModel[0]?.holdable
        this.accumulatedDecision = this.getAccumulatedDecision()
    },

    computed: {
        salesOrderProductsByIdentifier() {
            return _.chain(this.salesOrder.sales_order_lines)
                .keyBy('product_identifier')
                .mapValues(line => line.product_name)
                .value()
        },
        hasNotApprovableReason() {
            return this.holdModelType === "App\\Models\\Omt\\SalesOrder"
                && !this.getAccumulatedDecision()
                && this.holdReasonsForModel.some(reason => !reason.hold_rule_group?.is_approvable)
        },
    },

    methods: {
        getAccumulatedDecision() {
            if (this.holdReasonsForModel.some(r => r.hold_rule_group?.is_status_hold_final)) {
                return DECISION_STATUS_DENIED
            }

            let allDecisions = this.holdReasonsForModel.map(reason => reason.decision)

            if (allDecisions.indexOf(DECISION_STATUS_DENIED) !== -1) {
                return DECISION_STATUS_DENIED
            }

            if (allDecisions.filter(decision => decision === DECISION_STATUS_APPROVED).length === allDecisions.length) {
                return DECISION_STATUS_APPROVED
            }
            if (allDecisions.filter(decision => decision === DECISION_STATUS_INVALIDATED_BY_DATA_CHANGE).length === allDecisions.length) {
                return DECISION_STATUS_INVALIDATED_BY_DATA_CHANGE
            }

            return null
        },
        getProductNamesForHoldModel(holdModel) {
            let lines = holdModel.dispatch_request_lines ?? holdModel.sales_order_lines
            return lines?.map(line => {
                return `${line.quantity} &times; ${this.salesOrderProductsByIdentifier[line.product_identifier]}`
            })
        },
        formatDateTime(datetime) {
            return new Date(datetime).toLocaleString()
        },
    }
}
</script>
